import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';

import { getUserSetting } from '../helpers/Settings';

const HelpIcon = ({
  id,
  url,
  placement,
  children,
  permanent,
  tooltip,
  autohide,
}) => {
  if (!permanent) {
    return null;
  }

  if (!getUserSetting('show_help_tooltips') && !permanent) {
    return null;
  }

  return (
    <>
      {' '}
      <a
        href={url}
        id={id}
        onClick={(e) => {
          if (url === '#help') {
            e.preventDefault();
          }
        }}
        target="_blank"
        rel="noopener noreferrer"
        className="help-icon"
      >
        <i className="far fa-question-circle" />
        {(url === '#help' || tooltip) && (
          <UncontrolledTooltip
            target={id}
            placement={placement}
            boundariesElement="viewport"
            fade={false}
            autohide={autohide}
            className={`${id}-inner`}
          >
            {children}
          </UncontrolledTooltip>
        )}
      </a>
    </>
  );
};

HelpIcon.propTypes = {
  id: PropTypes.string,
  url: PropTypes.string,
  placement: PropTypes.string,
  autohide: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  permanent: PropTypes.bool,
  tooltip: PropTypes.bool,
};

HelpIcon.defaultProps = {
  id: 'help-tooltip',
  url: '#help',
  placement: 'auto',
  autohide: true,
  children: null,
  permanent: false,
  tooltip: false,
};

export default HelpIcon;
